import { Slackey, Noto_Sans } from 'next/font/google';

const slackey = Slackey({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-slackey',
  weight: ['400'],
});

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

export const supportedFonts = [slackey, notoSans];
